import React from 'react';
import { connect } from 'react-redux';

import amplitude from 'amplitude-js';
import { toggleModal, togglePopup, toggleSpinner, updateMessages, updateReduxAction, toggleSnackBar } from 'apps/promo/actions/appAction';
import { toggleChat } from 'apps/promo/actions/chatAction';
import { setExtra } from 'apps/promo/actions/extraAction';
import { setNewForm } from 'apps/promo/actions/formAction';
import { updateJsMessages, updatePageMessages } from 'apps/promo/actions/messageAction';
import { initTagManagerOnce } from 'apps/promo/analytics/analytics';
import WSChat from 'apps/promo/components/chat/WSChat';
import { AMPLITUDE_API_KEY, setAmplitudeNoopInstance } from 'apps/promo/components/utils/AmplitudeUtils';
import { COUNTRY_OF_RESIDENCE } from 'apps/promo/constants/amplitude/AmplitudeParamName';
import update from 'apps/promo/helpers/Immutability';
import { ConsentService } from 'apps/promo/services/ConsentService';
import { UpdateReduxService } from 'apps/promo/services/UpdateReduxService';

export default function BasePageForNoAuth(PageComponent) {
    class BasePageForNoAuth extends React.Component {
        constructor(props) {
            super(props);

            this.updateReduxService = new UpdateReduxService(props.lang);
            this.updateReduxService.setMessageAction(props.updateJsMessages, props.updatePageMessages);
            this.updateReduxService.setFormAction(props.setNewForm);
            this.updateReduxService.setAppAction(props.toggleModal, props.togglePopup, props.toggleSpinner, props.updateMessages);
            this.updateReduxService.setExtraAction(props.setExtra);
            this.updateReduxService.setStateOptions(props.stateOptions);

            const data = __isBrowser__ ? window.__INITIAL_DATA__ : props.staticContext ? props.staticContext.json : props.data;

            this.state = { data: data, loading: props.updateRedux };

            this.amplitudeInitialized = false;
        }

        componentDidMount() {
            if (this.props.updateRedux) {
                this.updateReduxService.fetchData(this.props.lang, this.props.isAuthZone, this.props.country).then((data) => {
                    this.setState(
                        update(this.state, {
                            data: { $set: data },
                            loading: { $set: false },
                        }),
                    );
                });
            } else {
                this.props.updateReduxAction();
            }
            window.scrollTo(0, 0);
            if (__isBrowser__ && __isProd__) {
                initTagManagerOnce();
            }
            if (!__isProd__) {
                setAmplitudeNoopInstance();
            }
            if (__isBrowser__) {
                const tryInitAnalytics = () => {
                    if (!ConsentService.hasLoaded()) return;
                    const { analytics } = ConsentService.getConsentState();

                    if (analytics) {
                        // Init / re-enable Amplitude
                        if (__isProd__) {
                            if (!this.amplitudeInitialized) {
                                const userId = this.props.auth?.phone ? this.props.auth?.phone : null;
                                const userCountry = this.props.userCountry?.nameEn;
                                amplitude.getInstance().init(AMPLITUDE_API_KEY, userId, {
                                    serverZone: 'EU',
                                    serverZoneBasedApi: true,
                                });
                                if (userCountry) {
                                    amplitude.getInstance().setUserProperties({
                                        [COUNTRY_OF_RESIDENCE]: userCountry,
                                    });
                                }
                                this.amplitudeInitialized = true;
                            } else {
                                // Re-enable if previously opted out
                                try {
                                    amplitude.getInstance().setOptOut(false);
                                } catch (e) {
                                    if (__isDev__) {
                                        console.warn('[Consent][Promo] Failed to re-enable Amplitude', e);
                                    }
                                }
                            }
                        }
                    } else {
                        // Disable Amplitude
                        if (this.amplitudeInitialized) {
                            try {
                                amplitude.getInstance().setOptOut(true);
                            } catch (e) {}
                            this.amplitudeInitialized = false;
                        }
                        setAmplitudeNoopInstance();
                    }
                };

                tryInitAnalytics();
            }
            if (__isBrowser__ && !this.props.auth?.ballId) {
                sessionStorage?.removeItem('isLoggedIn');
            }
        }

        componentDidUpdate(prevProps) {
            if (this.props.lang !== prevProps.lang) {
                this.updateReduxService.fetchData(this.props.lang, this.props.isAuthZone, this.props.country);
            }
        }

        render() {
            return (
                <>
                    <PageComponent {...this.props} loading={this.state.loading} data={this.state.data} />
                    {this.props.stateOptions?.showChat && <WSChat />}
                </>
            );
        }
    }

    const mapStateToProps = (state) => {
        return {
            app: state.app,
            updateRedux: state.app.updateRedux,
            auth: state.auth,
            lang: state.language.lang,
            country: state.app.country,
            showBrexitTerms: state.extra.showBrexitTerms,
            userCountry: state.extra?.userCountry,
        };
    };

    return connect(mapStateToProps, {
        updateReduxAction,
        togglePopup,
        toggleModal,
        updatePageMessages,
        updateJsMessages,
        setNewForm,
        updateMessages,
        toggleSpinner,
        setExtra,
        toggleChat,
        toggleSnackBar,
    })(BasePageForNoAuth);
}
